import { IconName } from '@infotech-soe/erp-ui-kit';
import { CommandHotKey, THotKey } from '@infotech-soe/metaschema';

import {
  BuiltinCaptionType,
  Caption,
  CaptionType,
} from '../../../models/caption/Caption';
import { ClientContext } from '../../context/IContextService';
import { CommandName } from '../CommandViewModel';

import CategoryCommand from './CategoryCommand';

class CopyCommand extends CategoryCommand<void> {
  public static COMMAND_NAME = 'copy' as const;

  public async getCaption(): Promise<Caption> {
    return {
      type: CaptionType.BUILT_IN,
      caption: BuiltinCaptionType.COPY,
    };
  }

  public getIcon(): IconName {
    return 'file';
  }

  public getHotKey(): THotKey {
    return CommandHotKey.Copy;
  }

  public getName(): CommandName {
    return CopyCommand.COMMAND_NAME;
  }

  public isAvailable(context: ClientContext): boolean {
    return context.has('Id');
  }
}

export default CopyCommand;
